<div class="container-fluid w-100">
  <div class="row h-100">
    <div class="col-12 col-sm-5 col-md-5 col-lg-4 bg-danger">
      <div class="px-1 py-3 px-lg-3 text-white text-sm-right top-25 position-relative">
        <h2 class="title mt-2 mt-lg-4">ERA</h2>
        <p class="mt-2 mt-lg-4"
           i18n>An unknown error has occurred. Please contact support.</p>
      </div>
    </div>
    <div class="col-12 col-sm-7 col-md-5 col-lg-4 align-self-top align-self-lg-stretch sidebar h-100">
      <div class="px-1 py-3 px-lg-3 text-start top-25 position-relative">
        <h3 class="title text-danger mt-2 mt-lg-4"
            i18n>Error</h3>
        <p>Insert message here</p>
      </div>
    </div>
  </div>
</div>